import { TrustpilotService } from './../services/cms/trustpilot.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from '../services/core/api.service';
import { ModelService } from './model/model.service';

import { ComponentHelperService } from '../services/core/component-helper.service';
import { TemplateService } from '../services/settings/template.service';
import { CmsContentService } from '../services/cms/cms-content.service';
import { CompanyService } from '../services/core/company.service';
import { ArticleService } from '../services/cms/article.service';
import { CmsMenuListService } from '../services/cms/cms-menu-list.service';
import { FaqListService } from '../services/cms/faq.service';
import { NewsletterService } from '../services/cms/newsletter.service';
import { SliderService } from '../services/cms/slider.service';
import { InfoRequestService } from '../services/cms/info-request.service';
import { LoginService } from '../services/cms/login.service';
import { RecoverPasswordService } from '../services/cms/recover-password.service';
import { RegisterService } from '../services/cms/register.service';
import { LocalStorageService } from '../services/core/local-storage';
import { QuotingService } from '../services/document/quoting.service';
import { CategoryService } from '../services/inventory/category.service';
import { ProductService } from '../services/inventory/product.service';
import { ShoppingCartService } from '../services/inventory/shopping-cart.service';
import { ClientAreaService } from '../services/settings/client-area.service';
import { AuthService } from '../services/core/auth.service';
import { LanguageService } from '../services/cms/language.service';
import { ConfigurationService } from '../services/core/configuration.service';
import { CmsComponentService } from '../services/cms/cms-component.service';
import { SeoService } from '../services/core/seo.service';
import { PrivacyPolicyService } from '../services/core/privacy-policy.service';
import { CookiePolicyService } from '../services/core/cookie-policy.service';
import { PurchaseConditionService } from '../services/core/purchase-condition.service';
import { BootboxService } from '../services/core/bootbox.service';
import { LoadingOverlayService } from '../services/core/loading-overlay.service';
import { ScriptService } from '../services/cms/script.service';
import { HelperService } from '../services/core/helper.service';
import { OrderPaymentService } from "../services/cms/order-payment.service";
import { CurrencyService } from "../services/cms/currency.service";
import { MessagesService } from "../services/core/messages.service";
import { ApplicationService } from '../services/core/application.service';
import { SearchService } from '../services/inventory/search.service';
import { BreadcrumbsService } from '../services/cms/breadcrumbs.service';
import { ValidationService } from '../services/core/validation.service';
import { CheckIfExistService } from '../services/cms/check-existence.service';

//Components  
import { HeaderComponent } from '../components/cms/header/widget/header.component';
import { FooterComponent } from '../components/cms/footer/widget/footer.component';
import { ArticleCategoryComponent } from '../components/cms/article/sys/article-category.component';
import { BlogPageComponent } from '../components/cms/article/sys/blog-page.component';
import { ArticleComponent } from '../components/cms/article/sys/news-page.component';
import { NewsListComponent } from '../components/cms/article/widget/news-list.component';
import { SideBarMenuComponent } from '../components/cms/homepage/widget/side-bar-menu.component';
import { NewsletterComponent } from '../components/cms/footer/widget/newsletter.component';
import { QuotingMainComponent } from '../components/document/widget/quoting/quoting-main.component';
import { WizardCommercialeComponent } from '../components/document/widget/quoting/wizard/form/wizard-form-commerciale.component';
import { WizardEditoriaComponent } from '../components/document/widget/quoting/wizard/form/wizard-form-editoria.component';
import { WizardAdesiviComponent } from '../components/document/widget/quoting/wizard/form/wizard-form-adesivi.component';
import { WizardBannerComponent } from '../components/document/widget/quoting/wizard/form/wizard-form-banner.component';
import { WizardBusteComponent } from '../components/document/widget/quoting/wizard/form/wizard-form-buste.component';
import { WizardEtichetteComponent } from '../components/document/widget/quoting/wizard/form/wizard-form-etichette.component';
import { WizardStampaComponent } from '../components/document/widget/quoting/wizard/form/wizard-form-stampa.component';
import { OtherProductFormComponent } from '../components/document/widget/quoting/other-product-form.component';
import { QuotingOrderTotalsComponent } from '../components/document/widget/quoting-result/wizard/widget/quoting-order-totals.component';
import { RegisterComponent } from '../components/settings/user/sys/register.component';
import { CookiePolicyComponent } from '../components/cms/page/sys/cookie-policy.component';
import { FaqComponent } from '../components/cms/page/sys/faq.component';
import { InfoRequestComponent } from '../components/cms/page/sys/info-request.component';
import { PrivacyPolicyComponent } from '../components/cms/page/sys/privacy-policy.component';
import { PurchaseConditionComponent } from '../components/cms/page/sys/purchase-condition.component';
import { CartEmptyPageComponent } from '../components/core/sys/cart-empty-page.component';
import { ClientAreaOrderListComponent } from '../components/document/sys/client-area-order-list.component';
import { OtherProductComponent } from '../components/inventory/product/sys/other-product.component';
import { PromotionsComponent } from '../components/inventory/product/sys/promotions.component';
import { UserLoginComponent } from '../components/settings/user/sys/user-login.component';
import { UserPasswordComponent } from '../components/settings/user/sys/user-password.component';
import { CartComponent } from '../components/inventory/shopping-cart/sys/cart.component';
import { ClientAreaHomeComponent } from '../components/settings/client-area/sys/client-area-home.component';
import { ClientAreaProfileComponent } from '../components/settings/client-area/sys/client-area-profile.component';
import { CartCashComponent } from '../components/inventory/shopping-cart/sys/cart-cash.component';
import { CartSubmittedComponent } from '../components/inventory/shopping-cart/sys/cart-submitted.component';
import { SliderWidgetComponent } from '../components/core/widget/slider-widget.component';
import { ClientAreaOrderDetailsComponent } from '../components/settings/client-area/sys/client-area-order-details.component';
import { OfflinePageComponent } from '../components/core/sys/offline-page.component';
import { NotFoundPageComponent } from '../components/core/sys/not-found-page.component';
import { RegistrationConfirmationComponent } from "../components/settings/user/sys/registration-confirmation.component";
import { PaymentConfirmationComponent } from "../components/settings/client-area/sys/payment-confirmation.component";
import { PaymentUnicreditConfirmationComponent } from "../components/settings/client-area/sys/payment-unicredit-confirmation.component";
import { Ng2TableModule} from 'ng2-table/ng2-table';
import { Mappings } from './mapping';
import { DatepickerModule } from 'angular2-material-datepicker';
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { CryptoService } from '../services/core/crypto.service';
import { SearchComponent } from '../components/cms/header/widget/search.component';
import { ClientAreaInvoicesComponent } from '../components/settings/client-area/sys/client-area-invoices.component';
import { NewsletterPageComponent } from './../components/cms/page/sys/newsletter-page.component';
import { NewsletterConfirmationPageComponent } from './../components/cms/page/sys/newsletter-confirmation-page.component';
import { RegistrationConfirmationPageComponent } from './../components/settings/user/sys/registration-complete.component';
import { CustomersCanvasService } from './../services/inventory/customerscanvas.service';
import { CanvasWidgetComponent } from '../components/core/widget/canvas-widget.components';
import { PaypalService } from '../services/core/paypal.service';
import { QuickRegistrationComponent } from '../components/settings/user/sys/quick-registration.component';
import { TrustpilotWidgetComponent } from '../components/core/widget/trustpilot-widget.component';
import { HeaderService } from '../services/cms/header.service';

const MODULES = [
  // Do NOT include UniversalModule, HttpModule, or JsonpModule here
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  Ng2TableModule,
  DatepickerModule,
  Ng2Bs3ModalModule,
  ];

const PIPES = [
  // put pipes here
];

const COMPONENTS = [
  // put shared components here
  HeaderComponent,
  FooterComponent,
  ArticleCategoryComponent,
  BlogPageComponent,
  ArticleComponent,
  NewsListComponent,
  SideBarMenuComponent,
  NewsletterComponent,
  QuotingMainComponent,
  WizardCommercialeComponent,
  WizardEditoriaComponent,
  WizardAdesiviComponent,
  WizardBannerComponent,
  WizardBusteComponent,
  WizardEtichetteComponent,
  WizardStampaComponent,
  OtherProductFormComponent,
  QuotingOrderTotalsComponent,
  CookiePolicyComponent,
  FaqComponent,
  InfoRequestComponent,
  PrivacyPolicyComponent,
  PurchaseConditionComponent,
  CartEmptyPageComponent,
  ClientAreaOrderListComponent,
  ClientAreaInvoicesComponent,
  UserLoginComponent,
  UserPasswordComponent,
  CartComponent,
  ClientAreaHomeComponent,
  ClientAreaProfileComponent,
  CartCashComponent,
  CartSubmittedComponent,
  SliderWidgetComponent,
  ClientAreaOrderDetailsComponent,
  RegistrationConfirmationComponent,
  PaymentConfirmationComponent,
  PaymentUnicreditConfirmationComponent,
  OfflinePageComponent,
  NotFoundPageComponent,
  SearchComponent,
  NewsletterPageComponent,
  NewsletterConfirmationPageComponent,
  RegistrationConfirmationPageComponent,
  CanvasWidgetComponent,
  QuickRegistrationComponent,
  TrustpilotWidgetComponent
];

const PROVIDERS = [
  ModelService,
  ApiService,
  ComponentHelperService,
  TemplateService,
  CmsContentService,
  CompanyService,
  ArticleService,
  CmsMenuListService,
  FaqListService,
  NewsletterService,
  SliderService,
  InfoRequestService,
  LoginService,
  RecoverPasswordService,
  RegisterService,
  LocalStorageService,
  QuotingService,
  CategoryService,
  ProductService,
  ShoppingCartService,
  ClientAreaService,
  AuthService,
  LanguageService,
  ConfigurationService,
  ApplicationService,
  Mappings,
  CmsComponentService,
  SeoService,
  PrivacyPolicyService,
  CookiePolicyService,
  PurchaseConditionService,
  BootboxService,
  LoadingOverlayService,
  MessagesService,
  CheckIfExistService,
  OrderPaymentService,
  ScriptService,
  HelperService,
  CurrencyService,
  CryptoService,
  SearchService,
  BreadcrumbsService,
  ValidationService,
  CustomersCanvasService,
  PaypalService,
  TrustpilotService,
  HeaderService
];

@NgModule({
  imports: [
    ...MODULES
  ],
  declarations: [
    ...PIPES,
    ...COMPONENTS
  ],
  exports: [
    ...MODULES,
    ...PIPES,
    ...COMPONENTS
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        ...PROVIDERS
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/shared/shared.module.ts